/*LIBRARY*/
import { Component } from "react";
import { Route, Router, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import muiTheme from "../Style/muiMapidTheme";

/*COMPONENT*/
import Navigation from "../Components/layout/Navigation";
import MODAL_SHARE_LINK from "../Components/trivial_components/MODAL_SHARE_LINK";
import SNACKBAR_PARENT from "../Components/common_modal/SNACKBAR_PARENT";
import BlogRead from "../Pages/dashboard/BlogRead";
import CreateForm from "../Pages/dashboard/CreateForm";
import PROJECT_DASHBOARD from "../Pages/dashboard/PROJECT_DASHBOARD";
import DashboardPublic from "../Pages/dashboard/DashboardPublic";
import EditProfile from "../Pages/user_and_group/EditProfile";
import GROUP_LIST_DASHBOARD from "../Pages/user_and_group/GROUP_LIST_DASHBOARD";
import GROUP_DETAIL from "../Pages/user_and_group/GROUP_DETAIL";
import LandingForgetPassword from "../Pages/auth/LandingForgetPassword";
import LandingLogin from "../Pages/auth/LandingLogin";
import LandingRegister from "../Pages/auth/LandingRegister";
// import PaymentList from "../Pages/dashboard/PaymentList";
import RoutingAccess from "../Pages/user_and_group/RoutingAccess";
import UserDashboard from "../Pages/user_and_group/UserDashboard";
import PARENT_MAP_EDITOR from "../Pages/map/PARENT_MAP_EDITOR";
import PARENT_MAP_VIEWER from "../Pages/map/PARENT_MAP_VIEWER";
import PARENT_INSIGHT from "../Pages/map/PARENT_INSIGHT";
// import PAGE_SINI from "../Pages/map/PAGE_SINI";
import PaymentInstruction from "../Pages/dashboard/PaymentInstruction";
import Recovery from "../Pages/dashboard/Recovery";
import BI_PAGE from "../Pages/map/BI_PAGE";
import CollaboratorsMenu from "../Pages/user_and_group/CollaboratorsMenu";
import GROUP_MENU from "../Pages/user_and_group/groupMenu";
import DeleteAccount from "../Pages/user_and_group/DeleteAccount";
import FloodSystemAnalysis from "../Pages/user_and_group/FloodSystemAnalysis";

//test aja
// import TestTable from "../Pages/dashboard/testTable";
/*REDUX*/
import {
  setCurrentUser,
  getUserFromToken,
  setPathname,
  setPrevPathname,
  get_quota_access,
  get_quota_access_sini_ai,
  get_quota_ai_chat,
  logoutUser,
  setLanguage,
} from "../App/actions/authActions";
import { getUserPaymentList } from "../App/actions/paymentActions";
import { optimized_get_user_license } from "../App/actions/license_actions";

/*PICTURE*/

/*FUNCTION*/
import { PrivateRoute } from "../App/validation";
import history from "../App/actions/history";
import store from "./store";

/*DATA*/
/*CSS MAIN*/
import "../Style/main/color.css";
import "../Style/main/container.css";
import "../Style/main/main_tag.css";
import "../Style/main/shape.css";
import "../Style/main/variable.css";
/*CSS TRIVIAL*/
import "../Style/trivial/old.css";
import "../Style/trivial/chat_container.css";
import "../Style/trivial/animation.css";
import "../Style/trivial/Rich.css";
import "../Style/trivial/SingleStyle.css";
import "../Style/trivial/bi.css";
import "../Style/trivial/map_control.css";
import "../Style/trivial/map_control_draw.css";
import "../Style/trivial/tree_diagram.css";
import "../Style/trivial/tooltip.css";
import ErrorBoundary from "./ErrorHandler/ErrorBoundary";
import ErrorUI from "./ErrorHandler/ErrorUI";
import { ErrorProvider } from "./ErrorHandler/ErrorContext";
import ErrorUIBoundary from "./ErrorHandler/ErrorUIBoundary";
import NotFoundPage from "../Pages/dashboard/NotFoundPage";

/*CONST*/
const token_mapid = localStorage.token_mapid;

if (token_mapid && token_mapid !== "undefined" && token_mapid !== undefined) {
  store.dispatch(
    setCurrentUser(JSON.parse(localStorage.getItem("mapid_user")))
  );
  store.dispatch(getUserFromToken(token_mapid));
  store.dispatch(getUserPaymentList());
  store.dispatch(get_quota_access());
  store.dispatch(get_quota_access_sini_ai());
  store.dispatch(get_quota_ai_chat());
  await store.dispatch(optimized_get_user_license());
} else {
  store.dispatch(logoutUser());
}

class App extends Component {
  componentDidMount() {
    const language = localStorage?.language;
    if (!!language) {
      store.dispatch(setLanguage(language));
    } else {
      store.dispatch(setLanguage("ina"));
    }

    let prevPath = history.location.pathname;
    this.unlisten = history.listen((location, action) => {
      store.dispatch(setPrevPathname(prevPath));
      store.dispatch(setPathname(location.pathname));
      prevPath = location.pathname;
    });

    window.addEventListener("wheel", this.handleWheel, { passive: false });
  }

  componentWillUnmount() {
    window.removeEventListener("wheel", this.handleWheel);
    if (this.unlisten) {
      this.unlisten();
    }
  }

  handleWheel = (e) => {
    const active = document.activeElement;
    if (
      active &&
      active.type === "number" &&
      active === document.activeElement
    ) {
      e.preventDefault(); // cegah scroll ubah angka
    }
  };

  render() {
    return (
      <Provider store={store}>
        <ErrorProvider>
          <ThemeProvider theme={muiTheme}>
            <Router history={history}>
              <ErrorBoundary fallback={<ErrorUIBoundary />}>
                <div>
                  <Switch>
                    {/* Public */}
                    <Route exact path="/" component={DashboardPublic} />
                    <Route exact path="/login" component={LandingLogin} />
                    <Route exact path="/login_qa" component={LandingLogin} />
                    <Route exact path="/register" component={LandingRegister} />
                    <Route
                      exact
                      path="/forget-password"
                      component={LandingForgetPassword}
                    />
                    {/* blog */}
                    <Route exact path="/blog_read/:link" component={BlogRead} />
                    <Route
                      exact
                      path="/public/:mode"
                      component={DashboardPublic}
                    />
                    <Route exact path="/insight" component={PARENT_INSIGHT} />
                    {/* <Route exact path="/sini" component={PAGE_SINI} /> */}

                    {/* PROJECT, LAYER, BI */}
                    <PrivateRoute
                      exact
                      path="/dashboard"
                      component={PROJECT_DASHBOARD}
                    />
                    <PrivateRoute
                      exact
                      path="/editor/:geo_project_link/:geo_layer_link?/:mode?"
                      component={PARENT_MAP_EDITOR}
                    />
                    <Route
                      exact
                      path="/view/:geo_project_link"
                      component={PARENT_MAP_VIEWER}
                    />

                    <PrivateRoute exact path="/bi/:link" component={BI_PAGE} />
                    {/* <PrivateRoute exact path="/test" component={TestTable} /> */}

                    {/* Profile */}
                    <PrivateRoute
                      exact
                      path="/user_profile"
                      component={UserDashboard}
                    />
                    <PrivateRoute
                      exact
                      path="/editprofile"
                      component={EditProfile}
                    />
                    {/* <PrivateRoute
                    exact
                    path="/purchase_list"
                    component={PaymentList}
                  /> */}
                    <PrivateRoute
                      exact
                      path="/routing_access"
                      component={RoutingAccess}
                    />
                    {/* Form */}
                    <PrivateRoute
                      exact
                      path="/form_editor/:geo_layer_link"
                      component={CreateForm}
                    />
                    {/* Delete Account */}
                    <PrivateRoute
                      exact
                      path="/delete_account"
                      component={DeleteAccount}
                    />
                    {/* Flood Analysis System */}
                    <PrivateRoute
                      exact
                      path="/flood_analysis_system"
                      component={FloodSystemAnalysis}
                    />
                    {/* Group & payment */}
                    <PrivateRoute
                      exact
                      path="/user_group/group"
                      component={() => (
                        <GROUP_LIST_DASHBOARD>
                          <GROUP_MENU />
                        </GROUP_LIST_DASHBOARD>
                      )}
                    />

                    <PrivateRoute
                      exact
                      path="/user_group/collaborator"
                      component={() => (
                        <GROUP_LIST_DASHBOARD>
                          <CollaboratorsMenu />
                        </GROUP_LIST_DASHBOARD>
                      )}
                    />

                    <PrivateRoute
                      exact
                      path="/group/:id"
                      component={GROUP_DETAIL}
                    />
                    <PrivateRoute
                      exact
                      path="/payment/:payment_id"
                      component={PaymentInstruction}
                    />
                    {/* Trash */}
                    <PrivateRoute exact path="/recovery" component={Recovery} />

                    <Route path="*" component={NotFoundPage} />
                  </Switch>

                  <Navigation />
                  <MODAL_SHARE_LINK />
                  <style>{`
                    #startingLoader { 
                      display: none;
                    }
                    /* Ensure smooth transition */
                    body {
                      transition: opacity 0.3s ease-in-out;
                    }
                  `}</style>
                </div>
                <SNACKBAR_PARENT />
                <ErrorUI />
              </ErrorBoundary>
            </Router>
          </ThemeProvider>
        </ErrorProvider>
      </Provider>
    );
  }
}

export default App;
